export const CAMPAIGN_BRAND_CODES = ['BOT', 'QDB', 'BLZ', 'EUD'] as const

export type CampaignBrandCode = (typeof CAMPAIGN_BRAND_CODES)[number]

export const INITIAL_CAMPAIGN_BRAND_FLAGS: Record<CampaignBrandCode, boolean> = {
  BOT: false,
  QDB: false,
  BLZ: false,
  EUD: false
}
